import React, { useEffect, useState } from "react"
import { useSearchParams, Link, useNavigate } from "react-router-dom"
import { verifyPayment } from "../services/payments"

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const orderId = searchParams.get("orderId")
  const txRef = searchParams.get("tx_ref") || searchParams.get("txRef")
  const transactionId = searchParams.get("transaction_id") || searchParams.get("transactionId")
  const [order, setOrder] = useState(null)
  const [payment, setPayment] = useState(null)
  const [tickets, setTickets] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (orderId || txRef || transactionId) {
      verifyAndFetchOrder()
    } else {
      setLoading(false)
      setError("No payment reference found")
    }
  }, [orderId, txRef, transactionId])

  const verifyAndFetchOrder = async () => {
    setLoading(true)
    try {
      const res = await verifyPayment({ orderId, txRef, transactionId })
      if (res.status === 200 && res.data) {
        setPayment(res.data.payment)
        setOrder(res.data.order)
        setTickets(res.data.tickets || [])
      } else {
        setError("Payment verification pending. Please check your tickets page.")
      }
    } catch (err) {
      console.error('Payment verification error:', err)
      setError("Payment successful! Please check your tickets page.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-white via-slate-50 to-white px-4 py-12">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <Link to="/" className="inline-flex items-center gap-2 text-2xl font-bold text-slate-900">
            <span className="text-cyan-600">Obule</span>
          </Link>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white p-8 shadow-lg">
          <div className="mb-6 text-center">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
              <svg className="h-8 w-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="mb-2 text-2xl font-bold text-slate-900">Payment Successful!</h1>
            <p className="text-sm text-slate-600">
              Your tickets have been issued successfully.
            </p>
          </div>

          {loading ? (
            <div className="mb-6 text-center">
              <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-cyan-600 border-r-transparent"></div>
              <p className="mt-3 text-sm text-slate-500">Verifying payment...</p>
            </div>
          ) : error ? (
            <div className="mb-6 rounded-lg border border-yellow-200 bg-yellow-50 p-4 text-sm text-yellow-800">
              {error}
            </div>
          ) : (
            <div className="mb-6 space-y-3 rounded-lg border border-slate-100 bg-slate-50 p-4">
              {order && (
                <div className="flex justify-between text-sm">
                  <span className="font-medium text-slate-600">Order ID:</span>
                  <span className="text-slate-900 font-mono text-xs">{order._id}</span>
                </div>
              )}
              {txRef && (
                <div className="flex justify-between text-sm">
                  <span className="font-medium text-slate-600">Transaction Ref:</span>
                  <span className="text-slate-900 font-mono text-xs">{txRef}</span>
                </div>
              )}
              {payment && payment.amount && (
                <div className="flex justify-between text-sm">
                  <span className="font-medium text-slate-600">Amount Paid:</span>
                  <span className="text-slate-900 font-semibold">
                    {payment.currency || 'NGN'} {Number(payment.amount).toLocaleString()}
                  </span>
                </div>
              )}
              {tickets.length > 0 && (
                <div className="flex justify-between text-sm">
                  <span className="font-medium text-slate-600">Tickets Issued:</span>
                  <span className="text-slate-900 font-semibold">{tickets.length}</span>
                </div>
              )}
              <div className="flex justify-between text-sm">
                <span className="font-medium text-slate-600">Status:</span>
                <span className="rounded-full bg-green-100 px-2.5 py-1 text-xs font-semibold text-green-700">
                  Completed
                </span>
              </div>
            </div>
          )}

          <div className="flex flex-col gap-3">
            <Link
              to="/account/tickets"
              className="w-full rounded-lg bg-cyan-600 px-4 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-cyan-700"
            >
              View My Tickets
            </Link>
            <Link
              to="/events"
              className="w-full rounded-lg border border-slate-300 bg-white px-4 py-3 text-center text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50"
            >
              Browse More Events
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentSuccess

